import { MessageCircle, Phone } from "lucide-react";
import { useLang } from "./LangContext";
import { useSettings, branchChannelLink } from "./SettingsContext";
import { Soon } from "./Reveal";

export const BranchContactLinks = ({ branch }) => {
  const { t } = useLang();
  const { settings } = useSettings();
  return (
    <div className="branch-contact-links" data-testid={`branch-contacts-${branch.id}`}>
      {t.contact.channels.filter((ch) => ["phone", "whatsapp"].includes(ch.icon)).map((ch) => {
        const link = branchChannelLink(branch.id, ch.icon, settings?.contact);
        const Row = link ? "a" : "div";
        const Icon = ch.icon === "phone" ? Phone : MessageCircle;
        return (
          <Row key={ch.icon} className={`branch-contact-row${link ? " is-link" : ""}`} href={link?.href}
            target={link?.external ? "_blank" : undefined} rel={link?.external ? "noopener noreferrer" : undefined}
            data-testid={`branch-contact-${branch.id}-${ch.icon}`}>
            <Icon size={17} aria-hidden="true" />
            <span className="branch-contact-label">{branch.city} {ch.label}</span>
            {link ? <span className="branch-contact-value">{link.text}</span> : <Soon text={t.contact.soon} testid={`branch-contact-soon-${branch.id}-${ch.icon}`} />}
          </Row>
        );
      })}
    </div>
  );
};
